import { render, staticRenderFns } from "./VariantDialogVuetify.vue?vue&type=template&id=1f8e59cc&scoped=true"
import script from "./VariantDialogVuetify.vue?vue&type=script&lang=js"
export * from "./VariantDialogVuetify.vue?vue&type=script&lang=js"
import style0 from "./VariantDialogVuetify.vue?vue&type=style&index=0&id=1f8e59cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e59cc",
  null
  
)

export default component.exports